const lessonSchedule = {
  state: {},
  getters: {},
  mutations: {},
};

export default lessonSchedule;
